import { z } from 'zod';

const BaseBookingSharingRequestSchema = z.object({
    id: z.string(),
    start_at: z.string(),
    end_at: z.string(),
    content: z.string(),
    creator_id: z.number(),
    cooperative_group_id: z.number().nullable(),
});

const RequestedBookingSharingRequestSchema = BaseBookingSharingRequestSchema.merge(
    z.object({
        status: z.literal('requested'),
    }),
);

const AssignedBookingSharingRequestSchema = BaseBookingSharingRequestSchema.merge(
    z.object({
        status: z.literal('assigned'),
        assigned_availability_id: z.string().nullable(), // TODO: remove nullable
        assigned_availability_creator: z.number().nullable(), // TODO: remove nullable
    }),
);

export const BookingSharingRequestSchema = z.union([
    RequestedBookingSharingRequestSchema,
    AssignedBookingSharingRequestSchema,
]);

export type BookingSharingRequest = z.infer<typeof BookingSharingRequestSchema>;

export const BookingSharingAvailabilitySchema = z.object({
    id: z.string(),
    start_at: z.string(),
    end_at: z.string(),
    content: z.string(),
    cooperative_group_id: z.number().nullable(),
    assigned_requests: z.array(BookingSharingRequestSchema),
    creator_id: z.number(),
});

export type BookingSharingAvailability = z.infer<typeof BookingSharingAvailabilitySchema>;
